import React from "react";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import TreeMenu from "react-simple-tree-menu";

// import default minimal styling or your own styling
import "../../../node_modules/react-simple-tree-menu/dist/main.css";

import Subcategory from "./Subcategory/Subcategory";

import { getListOfCategoriesForTreeView, getCategoryManagementListQuery, getListOfSubCategoriesForTreeView, getListOfCategoriesForCategoryViewUserQuery } from "../../services/graphql/queries/category-management";
import SelectComponent from "../Common/form-component/SelectComponent";
import { errorMessage } from "../../miscellaneous/error-messages";
import { errorMsg } from "../../miscellaneous/react-toastify";

class CategoryDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      error: "",
      activeMenu: 1,
      subcatName: "",
      referenceId: 0,
      subcategoryLevel: 1,
      category: [],
      projectOptions: [],
      filteredFolders: [],
      selectedProject: "",

      projectQuery: "",
      filteredProjects: [],
      showSuggestions: false,
      activeSuggestionIndex: -1,
    };
    this.changeMenu = this.changeMenu.bind(this);
    this.wrapperRef = React.createRef();
  }

  changeMenu(menu, props, label) {
    let arr = menu.split("/");
    let activeMenu, referenceId;
    if (props.level) {
      referenceId = parseInt(arr[arr.length - 1]);
      activeMenu = parseInt(arr[0]);
    } else {
      activeMenu = parseInt(arr[arr.length - 1]);
      referenceId = parseInt(arr[0]);
    }

    this.setState({
      activeMenu: activeMenu,
      referenceId: referenceId,
      subcategoryLevel: props.level + 1,
      subcatName: label,
    });
  }

  // getListofCategory() {
  //   this.setState({
  //     loading: true,
  //   });
  //   this.props.client
  //     .query({
  //       query: getListOfCategoriesForTreeView,
  //       variables: {},
  //       fetchPolicy: "network-only",
  //     })
  //     .then((result) => {
  //       var category = result.data.getListOfCategoriesForTreeView;
  //       category = JSON.parse(category);
  //       this.initialState = {
  //         category: category,
  //       };
  //       if (category.length === 0) {
  //         this.setState({
  //           loading: false,
  //           error: "",
  //           category: [],
  //         });
  //       }
  //       if (category.length)
  //         this.setState({
  //           ...this.initialState,
  //           activeMenu: category[0].key,
  //           subcatName: category[0].label,
  //           loading: false,
  //           error: "",
  //         });
  //     })
  //     .catch((error) => {
  //       console.log("~~~error: ", error);
  //       this.setState({ loading: false, error: error.message });
  //     });
  // }

  handleProjectInputChange = (e) => {
  const query = e.target.value;
  const filtered = this.state.projectOptions.filter((project) =>
    (`[${project.projectId}] ${project.name}`.toLowerCase().includes(query.toLowerCase()))
  );

  this.setState({
    projectQuery: query,
    filteredProjects: filtered,
    showSuggestions: true,
    activeSuggestionIndex: -1,
  });
};

handleSelectProject = (project) => {
  const selectedProjectId = project.id;
  this.setState({
    selectedProject: selectedProjectId,
    projectQuery: `[${project.projectId}] ${project.name}`,
    filteredProjects:this.state.projectOptions,
    showSuggestions: false,
    activeSuggestionIndex: -1,
  });
  this.getListOfFolders(selectedProjectId);
};

handleKeyDown = (e) => {
  const { activeSuggestionIndex, filteredProjects,projectQuery} = this.state;

  if (!filteredProjects || filteredProjects.length === 0) return;

  if (e.key === "ArrowDown") {
    e.preventDefault();
    const nextIndex =
      activeSuggestionIndex < filteredProjects.length - 1
        ? activeSuggestionIndex + 1
        : 0; 
    this.setState({ activeSuggestionIndex: nextIndex });
  } else if (e.key === "ArrowUp") {
    e.preventDefault();
    const prevIndex =
      activeSuggestionIndex > 0
        ? activeSuggestionIndex - 1
        : filteredProjects.length - 1;
    this.setState({ activeSuggestionIndex: prevIndex });
  } else if (e.key === "Enter") {
    e.preventDefault();

    let selected=null;
    if (activeSuggestionIndex >= 0) {
        selected = filteredProjects[activeSuggestionIndex];
    }
  else if (projectQuery.trim() === "") {
      selected = filteredProjects[0];
    }

    if (selected) {
      this.handleSelectProject(selected);
    }
  }
};

  getListOfProject() {
    this.props.client
      .query({
        query: getListOfCategoriesForCategoryViewUserQuery,
        variables: {},
        fetchPolicy: "network-only",
      })
      .then((result) => {
        var category = result.data.getListOfCategoriesForCategoryViewUser;
        this.initialState = {
          projectOptions: category,
        };
       // this.setState({ ...this.initialState, loading: false, error: "" });
       const defaultProjectId = category.length > 0 ? category[0].id : null;
       this.setState({
         ...this.initialState,
         loading: false,
         error: "",
         selectedProject: defaultProjectId, // Set default selected project ID
         projectQuery:
            defaultProjectId &&
            `[${category[0].projectId}] ${category[0].name}`,
          filteredProjects: category,         
       });
       if (defaultProjectId) {
        this.getListOfFolders(defaultProjectId); //automaticaaly select folder according to project
      }
      })
      .catch((error) => {
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({ loading: false, error: error.message });
      });
  }

  getListOfFolders(projectId) {
    this.props.client
      .query({
        query: getListOfSubCategoriesForTreeView,
        variables: {
          categoryId: projectId
        },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        var category_in = result?.data?.getListOfSubCategoriesForTreeView;
        console.log("categoryin",category_in);
        
        
        category_in = JSON.parse(category_in);

        this.initialState = {
          category: category_in,
        };
        if (category_in?.length === 0) {
          this.setState({
            loading: false,
            error: "",
            category: [],
          });
        }
        if (category_in?.length > 0)
          this.setState({
            ...this.initialState,
            activeMenu: category_in[0]?.key,
            subcatName: category_in[0]?.label,
            subcategoryLevel: category_in[0]?.level,
            referenceId: category_in[0]?.key,
            loading: false,
            error: "",
          });
          
      })
      .catch((error) => {
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({ loading: false, error: error.message });
      });
  }

  handleOutsideClick = (e) => {
  if (
    this.wrapperRef.current &&
    !this.wrapperRef.current.contains(e.target)
  ) {
    this.setState({ showSuggestions: false });
  }
};

  componentDidMount() {
    // this.getListofCategory();
    this.getListOfProject();
    document.addEventListener("mousedown", this.handleOutsideClick);
  }

  render() {
    const {
      loading,
      error,
      category,
      activeMenu,
      subcatName,
      selectedProject,
      referenceId,
      subcategoryLevel,
      projectOptions,
      filteredFolders
    } = this.state;
    // const activeProjectOptions = projectOptions.filter(
    //   (project) => project.statusDetail?.name === "Active"
    // );

    if (loading) {
      return <div>Loading...</div>;
    }
    if (error) {
      return <div>{error}</div>;
    }
    return (
      <>
        <div className="row">
          <div className="col-md-3">
            <h1 className="heading m-b-25">Document View</h1>
          </div>
          <div className="col-md-2 d-flex justify-content-end  bg-inf  pt-2"><span style={{fontWeight:"600", fontSize:""}}>PROJECT LIST<span style={{color:"red"}}>*</span>:</span></div>
          <div className="col-md-3 bg-warnin p-0" ref={this.wrapperRef} >
          {/* <SelectComponent
            required
            // label={"Project"}
            title={"project"}
            name={"project"}
            options={projectOptions.map((project)=>({
              id:project.id,
              name:`[${project.projectId}] ${project.name}`
            }))}
            optionKey={"name"}
            valueKey={"id"}
            placeholder={"Select Project"}
            handleChange={(e) => {
              const selectedProjectId = e.target.value;
              
              this.setState({selectedProject: selectedProjectId})
              this.getListOfFolders(selectedProjectId);
            }}
            value={this.state.selectedProject|| ""} 
            validator={this.validator}
            validation="required"
          /> */}

            <input
                type="text"
                className="form-control"
                placeholder="Type to search project"
                value={this.state.projectQuery}
                onChange={this.handleProjectInputChange}
                onClick={() => {
                  // if (this.state.projectQuery) this.setState({ showSuggestions: true });
                  this.setState({
                        showSuggestions: true,
                        activeSuggestionIndex: this.state.filteredProjects.findIndex(
                                  (p) => p.id === this.state.selectedProject
                          ),
                  });
                }}
                onKeyDown={this.handleKeyDown}
                required
                validator={this.validator}
                validation="required"
                optionKey={"name"}
                valueKey={"id"}
            />

              {this.state.showSuggestions && (
                <ul
                  className="suggestions-list"
                  style={{
                    position: "absolute",
                    top: "68%",
                    left: 0,
                    right: 0,
                    maxHeight: "auto", //240px
                    overflowY: "auto",
                    border: "1px solid #ccc",
                    backgroundColor: "#fff",
                    zIndex: 1000,
                    listStyleType: "none",
                    margin: 0,
                    padding: 0,
                    maxHeight:"40vh",
                  }}
                  ref={(el) => (this.suggestionsListRef = el)}
      >
      {this.state.filteredProjects.length > 0 ? (
        this.state.filteredProjects.map((project, index) => {
          // <li
          //   key={project.id}
          //   style={{ padding: "8px", cursor: "pointer" ,backgroundColor: project.id === this.state.selectedProject ? "#f0f0f0" : "#fff" }}
          //   onClick={() => this.handleSelectProject(project)}
          // >
          //   [{project.projectId}] {project.name}
          // </li>
          // const isHovered = project.id === this.state.hoveredProjectId;
          // const isSelected = index === this.state.activeSuggestionIndex;
          const isHovered = project.id === this.state.hoveredProjectId;
          const isSelected = project.id === this.state.selectedProject; 
          const isActive = index === this.state.activeSuggestionIndex; 

          return (
            <li
              key={project.id}
              ref={(el) => {
                            if (isActive && el) {
                              el.scrollIntoView({
                                block: "nearest", 
                              });
                            }
                    }}
              style={{
                padding: "6px 8px",
                cursor: "pointer",
                // backgroundColor: isSelected
                //   ? "#007bff"
                //   : isHovered
                //   ? "#f0f0f0"
                //   : "#fff",
                  backgroundColor: isSelected
                        ? "#007bff"      // blue 
                        : isActive
                        ? "#cce5ff"        // lighter blue 
                        : isHovered
                        ? "#f0f0f0"        // gray
                        : "#fff",
                color: isSelected ? "#fff" : "#000",
                fontSize: "15px",
              }}
              onMouseEnter={() =>
                this.setState({ hoveredProjectId: project.id})
              }
              onMouseLeave={() => this.setState({ hoveredProjectId: null })}
              onClick={() => this.handleSelectProject(project)}
            >
              [{project.projectId}] {project.name}
            </li>
          );
        })
      ) : (
        <li style={{ padding: "8px" }}>No matching projects</li>
      )}
    </ul>
  )}


          </div>
          <div className="col-md-4 bg-dange text-right">
            <button
              className="btn btn-danger"
              onClick={() =>
                this.props.history.push("/category-info-attachment-list")
              }
            >
              {/* <a href="/category-info-attachment-list"> */}
              Search
              {/* </a> */}
            </button>
          </div>
        </div>

        {category.length ? (
          <div className="row">
            <div className="col-md-4">
              <div
                className="box-card"
                style={{
                  overflowY: "auto",
                  overflowX: "auto",
                  minHeight: "100%",
                }}
              >
                <TreeMenu
                  data={category}
                  onClickItem={({ key, label, ...props }) => {
                    this.changeMenu(key, props, label);
                  }}
                  initialActiveKey={String(category[0].key)}
                />
              </div>
            </div>
            <div className="col-md-8">
              <Subcategory
                category={selectedProject}
                subcatName={subcatName}
                referenceId={referenceId}
                subcategoryLevel={subcategoryLevel}
              />
            </div>
          </div>
        ) : (
          <div className="row">
            <div className="col-md-12">
              <div
                className="box-card"
                style={{
                  textAlign: "center",
                  overflowY: "auto",
                  overflowX: "auto",
                  minHeight: "100%",
                }}
              >
                No Data
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default withRouter(connect()(withApollo(CategoryDetails)));
